import React, { lazy } from 'react';

const CostCodeLibraryListing = lazy(() =>
  import(
    'containers/GeneralSettingModule/CostCodeLibraryModule/CostCodeLibraryListing'
  ).then(module => ({
    default: module.CostCodeLibraryListing,
  })),
);

const costCodeLibraryRoutes = [
  {
    props: { exact: true, path: '/:mode/general-settings/cost-code-library' },
    component: <CostCodeLibraryListing />,
  },
];

export default costCodeLibraryRoutes;
